import { createSelector } from 'reselect';
import { getCurrentGruserSlice } from './grusers';
/* export const getLayout = (
  state: AppState,
  gruser: Gruser | undefined
): LayoutSlice | undefined => getCurrentGruserSlice(state, gruser)?.layout;
*/ export const getLayout = createSelector((state)=>state, (_, gruser)=>gruser, (state, gruser)=>{
    var _getCurrentGruserSlice;
    return (_getCurrentGruserSlice = getCurrentGruserSlice(state, gruser)) === null || _getCurrentGruserSlice === void 0 ? void 0 : _getCurrentGruserSlice.layout;
});
export const getVersion = (state, gruser)=>{
    var _getLayout;
    return (_getLayout = getLayout(state, gruser)) === null || _getLayout === void 0 ? void 0 : _getLayout.version;
};
export const getZones = (state, gruser)=>{
    var _getLayout;
    return ((_getLayout = getLayout(state, gruser)) === null || _getLayout === void 0 ? void 0 : _getLayout.zones) || {};
};
